import TooltipPopover from 'components/TooltipPopover';

interface ConfigFileUploadButtonProps {
  inputId: string;
  tooltipContent: string;
  buttonText: string;
  isLoading: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// Pill-shaped "Upload/Update Config File" button shared across the
// SettingsComp pages (AutoOptimize, ConsumerInt, Insights, Competitive_int).
function ConfigFileUploadButton({
  inputId,
  tooltipContent,
  buttonText,
  isLoading,
  onChange,
}: ConfigFileUploadButtonProps) {
  return (
    <div className="rounded-full shadow-md relative">
      <TooltipPopover
        content={tooltipContent}
        translate={false}
        type="info"
        side="top"
        tooltipWidth="w-96"
        infoStandalone={true}
      />
      <label
        htmlFor={inputId}
        className={`text-sm font-bold flex items-center justify-center gap-2 py-2 px-4 w-44 rounded-full bg-theme-1 text-light ${
          isLoading ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}
      >
        {isLoading ? (
          <span className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-light" />
        ) : (
          buttonText
        )}
      </label>
      <input
        type="file"
        id={inputId}
        className="hidden"
        accept=".xlsx"
        disabled={isLoading}
        onChange={onChange}
      />
    </div>
  );
}

export default ConfigFileUploadButton;
